
import { useNavigate, useParams } from "react-router-dom";
import { useInventarioXID } from "../../../hooks/cache";
import { CargandoMedio, ModalFormulario } from "../../components";
import { LayoutDesplegable } from "../../layouts";
import { FormCrearUpdateLote, TablaLotesStock } from "../components";
import { iconos } from "../../../data";
import { useLotesStore, useModalStore } from "../../../stores";
import { useListLotesXStock } from "../../../hooks/cache/ui/useLotesStock";




export const LotesXStock = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { modalFormToggle } = useModalStore();
    const { activarLote, setActivarLote } = useLotesStore();
    const { data:stock } = useInventarioXID(id); 
    const { data, isLoading, page, chagePage } = useListLotesXStock(id);
    const texto = (stock) ? `Producto: ${stock.nombre}` : 'Cargando información...';


    const handleCerrarModalInv = () => {
        setActivarLote(null);
        modalFormToggle(false);
    }


    const menu = [ 
        { title: 'Crear Lote', action:() => modalFormToggle(true), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];


    
    return (
        
        <LayoutDesplegable titulo="Lotes por Stock" subtitulo={texto} menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de lotes..." />
            :   <>
                <TablaLotesStock data={data || []} chagePage={chagePage} page={page} />
                </>
            }

            <ModalFormulario titulo={`${(activarLote) ? 'Editar' : 'Crear' } Lote`} valor={{}} onClose={ handleCerrarModalInv }>
                <FormCrearUpdateLote handleCerrarModalInv={handleCerrarModalInv} />
            </ModalFormulario>
        </LayoutDesplegable>
    )
}
